import { emptyRules, } from "openchat-shared";
export class ChatDetailsState {
    chatId;
    members;
    lapsedMembers;
    blockedUsers;
    invitedUsers;
    pinnedMessages;
    bots;
    webhooks;
    rules;
    constructor(chatId, members, lapsedMembers, blockedUsers, invitedUsers, pinnedMessages, bots, webhooks, rules = emptyRules()) {
        this.chatId = chatId;
        this.members = members;
        this.lapsedMembers = lapsedMembers;
        this.blockedUsers = blockedUsers;
        this.invitedUsers = invitedUsers;
        this.pinnedMessages = pinnedMessages;
        this.bots = bots;
        this.webhooks = webhooks;
        this.rules = rules;
    }
}
